<template lang="pug">
  v-dialog.grey(v-model="dialog" scrollable max-width="1100")
    template(v-slot:activator="{ on }")
      v-btn(v-on="on" @click="$emit('buttonClick')" color="primary") {{ buttonText }}
    v-card
      v-card-title.d-flex.flex-nowrap.justify-space-between.headline.text-center(primary-title)
        span {{ title }}
        v-btn(@click="dialog = false" icon)
          v-icon mdi-close
      v-card-text.fantasy__scrollbar.px-2.px-sm-6
        v-container(fluid)
          v-row
            v-col(cols="12")
              slot
</template>

<script>
  export default {
    name: "TeamsCompetitionInfoDialog",
    props:{
      buttonText: {
        type: String,
        default: 'Ver Equipos'
      },
      title: {
        type: String,
        default: 'Equipos de la competicion'
      },
    },
    data:() => ({
      dialog: false,
    })
  }
</script>

<style lang="sass">
</style>